// @ts-ignore
export const COMMENT_API_URL = commentApiUrl;
// @ts-ignore
export const ARTICLE_API_URL = articleApiUrl;
// @ts-ignore
export const TALK_API_URL = talkApiUrl;
// @ts-ignore
export const USER_HOME_API_URL = userHomeApiUrl;
// @ts-ignore
export const VOTE_POST_SURVEY_API_URL = voteApiUrl;
